import whereSteyFunc from '../services/whereSteyFunc';
// import clickIphone from '../services/clickIphone';
let p = 0;

const whereStay = (selector = false) => {
	try {
		// if (selector) {
		// 	return selector.addEventListener('click', e => {
		// 		console.log('hello===== is hereStay ');
		// 		whereSteyFunc(e, p);
		// 	});
		// }

		document
			.querySelector('#wheryIsty')
			.addEventListener('click', e => whereSteyFunc(e, p));
	} catch (error) {
		console.error(error);
	}
};

export default whereStay;
